import { toast } from "react-toastify";
import SummaryApi from "../common";
import { store } from "../store/store";
import { request } from "./request";

const addToCart = async (e, id, variantId = null) => {
  e?.stopPropagation();
  e?.preventDefault();

  const isLoggedIn = !!store.getState()?.user?.user;

  if (!isLoggedIn) {
    // Guest Cart logic
    let cart = JSON.parse(localStorage.getItem("guestCart") || "[]");
    const existingItem = cart.find(
      (item) => item.productId === id && item.variantId === (variantId || null),
    );

    if (existingItem) {
      toast.info("Product already in cart");
      return { success: false, message: "Already in cart" };
    }

    cart.push({ productId: id, variantId: variantId || null, quantity: 1 });
    localStorage.setItem("guestCart", JSON.stringify(cart));
    toast.success("Added to guest cart");

    // Dispatch custom event to update cart count in Header
    window.dispatchEvent(new Event("cartUpdate"));

    return { success: true, message: "Added to guest cart" };
  }

  try {
    const response = await request(SummaryApi.addToCartProduct, {
      body: JSON.stringify({ productId: id, variantId: variantId || null }),
    });

    const responseData = await response.json();

    if (responseData.success) {
      toast.success(responseData.message);
    }

    if (responseData.error) {
      toast.error(responseData.message);
    }

    return responseData;
  } catch (error) {
    console.error("Error adding to cart", error);
    toast.error("An error occurred. Please try again.");
    return { success: false, error: true };
  }
};

export default addToCart;
